module.exports = __webpack_public_path__ + "img/Medical_Case_pic02.bfeecf04.jpg";